import { format, formatDistanceToNowStrict, isValid, parseISO } from "date-fns"
import i18n, { dateLocale } from "@/i18n"

export function toDate(value: string | number | Date | null | undefined): Date | null {
  if (value == null || value === "") return null
  const d = value instanceof Date ? value : typeof value === "number" ? new Date(value) : parseISO(value)
  return isValid(d) ? d : null
}

/** "3 minutes ago" / "over 2 years ago" in the active language. */
export function formatRelative(value: string | number | Date | null | undefined, now = Date.now()): string {
  const d = toDate(value)
  if (!d) return ""
  if (Math.abs(now - d.getTime()) < 45_000) return i18n.t("time.justNow")
  return formatDistanceToNowStrict(d, { addSuffix: true, locale: dateLocale() })
}

/** Absolute timestamp, e.g. "8 Oct 2026, 14:03". */
export function formatDateTime(value: string | number | Date | null | undefined, pattern = "PPp"): string {
  const d = toDate(value)
  return d ? format(d, pattern, { locale: dateLocale() }) : ""
}

export function formatDate(value: string | number | Date | null | undefined): string {
  return formatDateTime(value, "PP")
}

export function formatNumber(n: number | null | undefined, opts?: Intl.NumberFormatOptions): string {
  if (n == null || Number.isNaN(n)) return "—"
  return new Intl.NumberFormat(dateLocale().code, opts).format(n)
}

/** Parse a user agent into a short "Chrome on macOS" style label. */
export function describeUserAgent(ua: string): { browser: string; os: string } {
  const browser = /Edg\//.test(ua)
    ? "Edge"
    : /OPR\//.test(ua)
      ? "Opera"
      : /Firefox\//.test(ua)
        ? "Firefox"
        : /Chrome\//.test(ua)
          ? "Chrome"
          : /Safari\//.test(ua)
            ? "Safari"
            : /curl\//.test(ua)
              ? "curl"
              : ua.split("/")[0] || "Unknown"
  const os = /Windows/.test(ua)
    ? "Windows"
    : /iPhone|iPad|iOS/.test(ua)
      ? "iOS"
      : /Mac OS X|Macintosh/.test(ua)
        ? "macOS"
        : /Android/.test(ua)
          ? "Android"
          : /Linux/.test(ua)
            ? "Linux"
            : ""
  return { browser, os }
}
